module.exports = __webpack_public_path__ + "static/media/chun_wei_hsu.2cd6fdbc.jpg";